// src/themes/lino/components/ProductHoverMedia.tsx
'use client';

import Image from 'next/image';

type ProductHoverMediaProps = {
    url: string;
    alt: string;
    sizes?: string;
    className?: string;
};

// آدرس ویدئوئه یا عکس؟ (بر اساس پسوند فایل)
function isVideoUrl(url: string) {
    return /\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(url);
}

// یه بلوک مستقل برای نمایش عکس/ویدئوی هاور روی کارت یا گالری محصول.
// خودش تشخیص می‌ده فایل عکسه یا ویدئو و رفتار پخش/فید مناسب رو اجرا
// می‌کنه. جای دیگه‌ای هم که لازم شد (کارت محصول، گالری صفحه محصول، …)
// همینو صدا بزن تا رفتار همه‌جا یکسان بمونه.
export default function ProductHoverMedia({
    url,
    alt,
    sizes = '(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 25vw',
    className = '',
}: ProductHoverMediaProps) {
    if (isVideoUrl(url)) {
        return (
            <video
                src={url}
                muted
                loop
                playsInline
                autoPlay={false}
                preload="metadata"
                className={`absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100 ${className}`}
                ref={el => {
                    if (!el) return;
                    // مطمئن می‌شیم muted واقعاً روی خودِ المنت هم ست شده
                    // (بعضی مرورگرها فقط با ست‌شدن مستقیم پراپرتی اجازه‌ی
                    // autoplay بی‌صدا رو می‌دن، نه فقط با اتریبیوت JSX)
                    el.muted = true;
                }}
                onMouseEnter={e => {
                    const video = e.currentTarget;
                    video.currentTime = 0;
                    const playPromise = video.play();
                    if (playPromise) playPromise.catch(() => { });
                }}
                onMouseLeave={e => e.currentTarget.pause()}
            />
        );
    }

    return (
        <Image
            src={url}
            alt={alt}
            fill
            sizes={sizes}
            className={`object-cover absolute inset-0 opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100 ${className}`}
        />
    );
}